/**
 * ドット区切り線（インライン）の表示条件を判定する
 * - Standardパス: 利用開始前のみ表示（利用中・利用済みは非表示）
 * - CenteredQRパス(非Standard): 利用中のみ表示
 * @param {boolean} isCenteredQR
 * @param {boolean} isStandard
 * @param {boolean} isValidPass
 * @returns {boolean}
 */
export const checkShouldShowDividerLine = ({
  isCenteredQR,
  isStandard,
  isValidPass,
}) => {
  const isValidPassAndCenteredQR = isValidPass && isCenteredQR;
  return (isValidPassAndCenteredQR && !isStandard) || (isStandard && !isValidPass);
};
